import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import './mode-selection.component.scss';
import { namespace } from 'vuex-class';
import { SortStoreConst } from '@/tsort/store/sort.store';
import { WorkInstruction } from '@/tsort/enum/work-instruction.enum';
import { ScanSystemMenuResponse } from '@/tsort/model/response/scan-system-menu-response.model';
import RouterUtils from '@/common/utils/router.util';
import AppConstants from '@/common/constants/app.constants';

const SortStore = namespace(SortStoreConst.SORT_STORE_MODULE_NAME);
@Component({})
export default class WorkInstructionModalComponent extends Vue {
  // Props mode selection
  @Prop() listWorkInstruction!: Array<ScanSystemMenuResponse>;

  // Define variavble
  uniqueWorkInstructions: Array<number> = [];

  // Start store
  @SortStore.Action
  updateWorkInstruction!: (value: WorkInstruction | string) => void;

  @SortStore.Getter
  workInstruction!: WorkInstruction;
  // End store

  /**
   * 変更リストの作業指示を見る。
   */
  @Watch('listWorkInstruction')
  async uniqueWorkTypesChange() {
    await this.filterWorkInstructionUnique();
    if (this.uniqueWorkInstructions.length === 1) {
      this.handleModalShowWorkInstruction(this.listWorkInstruction[0].workInstruction);
    } else {
      this.$bvModal.show('idWorkInstructionModal');
    }
  }

  /**
   * モーダルを閉じる。
   */
  private closeModal(): void {
    this.$bvModal.hide('idWorkInstructionModal');
    RouterUtils.goToRouterName(AppConstants.NAME_TOP_PAGE);
  }

  /**
   * イベントを公開 作業指示を選択
   *
   * @param workInstruction  作業指示
   * @returns                フィルタリングされた作業指示を一覧表示する
   */
  @Emit('workInstructionSelected')
  handleModalShowWorkInstruction(workInstruction: number) {
    // Update store when choose mode first
    this.updateWorkInstruction(workInstruction);
    this.$bvModal.hide('idWorkInstructionModal');
    return this.filterWorkType();
  }

  /**
   * 作業指示を一意にフィルタリングする。
   */
  private filterWorkInstructionUnique(): void {
    //filter data unique work instruction
    const listWorkInstructionUnique = [...new Set(this.listWorkInstruction.map((item) => item.workInstruction))];
    this.uniqueWorkInstructions = listWorkInstructionUnique.sort((a, b) => b - a);
  }

  /**
   * 作業指示フィルター。
   */
  private filterWorkType(): Array<ScanSystemMenuResponse> {
    //filter data unique work instruction
    const uniqueWorkInstructionSorting = [
      ...new Set(this.listWorkInstruction.filter((item) => item.workInstruction === this.workInstruction))
    ];
    return uniqueWorkInstructionSorting;
  }

  render() {
    return (
      <b-modal id="idWorkInstructionModal" centered no-close-on-backdrop={true} size="lg" hide-footer hide-header>
        <template class="modal-header border-bottom-0 d-flex flex-column align-items-center justify-content-center">
          <h3 class="font-weight-bold">モードを選択してください</h3>
          <span
            class="icon icon-close-modal-svg text-font cursor-pointer"
            onClick={() => {
              this.closeModal();
            }}
          ></span>
          <span class="text-size mb-2 mt-1">1/3</span>
        </template>
        <div class="row d-flex flex-row justify-content-center">
          {this.uniqueWorkInstructions?.map((item, index) => {
            return (
              <div class="col" key={index}>
                <b-card
                  class="card-shadow cursor-pointer"
                  align="center"
                  onClick={() => {
                    this.handleModalShowWorkInstruction(item);
                  }}
                >
                  <b-row class="h-100 justify-content-center align-items-center">
                    <b-col class="d-flex flex-column justify-content-center align-items-center">
                      <span class={`icon icon-work-induction-svg-${item}`}></span>
                      <span class="font-weight-bold h4">
                        {item === WorkInstruction.PARALLEL_SORTING ? '作業指示あり' : '作業指示なし'}
                      </span>
                    </b-col>
                  </b-row>
                </b-card>
              </div>
            );
          })}
        </div>
      </b-modal>
    );
  }
}
